import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_DASHBOARD_COMMANDER = 'FETCH_DASHBOARD_COMMANDER'
export const RECEIVE_DASHBOARD_COMMANDER = 'RECEIVE_DASHBOARD_COMMANDER'
export const FAILED_DASHBOARD_COMMANDER = 'RECEIVE_DASHBOARD_COMMANDER'

export function fetchCommanderDashboard(_data){
    return(dispatch, getState) => {
        dispatch({type: FETCH_DASHBOARD_COMMANDER})
        axios({
            method: 'POST',
            url: API_LINKS.DASHBOARD_COMMANDER_MAIN_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: {
                _data
            }
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_DASHBOARD_COMMANDER,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                }
            } else {
                dispatch({
                    type: FAILED_DASHBOARD_COMMANDER
                })
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 403) {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    dispatch({
                        type: FAILED_DASHBOARD_COMMANDER
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DASHBOARD_COMMANDER
                })
                return toast.error('Request have no response! Please check on your internet connection and refresh this page.')
            } else {
                dispatch({
                    type: FAILED_DASHBOARD_COMMANDER
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/dashboard/aDashboard-Commander.jsx